import { module } from 'modujs';
import { gsap } from 'gsap';

export default class extends module {
    constructor(m) {
        super(m);

        this.$panels = this.$('panel');
    }

    init() {
        this.resize();


        this.bindResize = this.resize.bind(this);
        window.addEventListener('resize', this.bindResize);
    }

    resize() {
        if(this.resizeTimeout != undefined) {
            this.resizeTimeout.kill();
        }
        this.resizeTimeout = gsap.delayedCall(0.3, () => {
            this.resizeDebounce();
        });
    }

    resizeDebounce() {
        let windowH = window.innerHeight;
        this.$panels.forEach(($panel) => {

            if($panel.getBoundingClientRect().height > windowH) {
                $panel.classList.add('-bottom');
                $panel.style.setProperty('--sticky-offset', `${windowH - $panel.getBoundingClientRect().height}px`);
            } else {
                $panel.classList.remove('-bottom');
            }
        });
    }

    destroy() {
        window.removeEventListener('resize', this.bindResize);
    }
}
